function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.82 8.7c.71-.39 1.58.12 1.57.93l-.04 5.42c-.01.82-.9 1.32-1.6.9l-4.68-2.8c-.7-.42-.68-1.44.03-1.83l4.72-2.62zm1.43-2.42c.15.38-.08.77-.44.97l-5.63 3.11c-.8.44-1.74-.27-1.54-1.15l1.22-5.53c.15-.7.94-1.04 1.56-.69l3.92 2.24c.43.25.74.62.91 1.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.01 2.67l-2.07 9.3c-.03.14-.03.29 0 .44l1.73 8.68c.12.6-.39 1.17-.89.8l-5.29-3.77c-.56-.4-.89-1.04-.89-1.72V7.09c0-.76.4-1.46 1.07-1.84l5.29-3.01c.15-.09.31-.15.47-.2.38-.13.66.25.58.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.63 16.81c.65.39.69 1.32.08 1.76l-3.47 2.52c-.62.45-1.51.11-1.66-.65l-1.02-5.2c-.18-.9.79-1.58 1.58-1.11l4.49 2.68z"
})));